import { useContext } from 'react'
import { useMutation } from 'react-query'
import { apiPost, apiPostQuery, apiPatch, apiDelete } from 'api'
import AuthContext from 'context/auth-context'

const createDashboardVendor = async (token, params, id) => {
  const objectName = 'dashboard_vendor'
  const url = `dashboards/${id}/dashboard_vendors`

  const data = await apiPost({ url, token, objectName, params })
  return data
}

export function useCreateDashboardVendor({ params, options }) {
  const token = useContext(AuthContext)

  return useMutation(
    () => {
      return createDashboardVendor(token, params, params.dashboard_id)
    },
    { ...options }
  )
}

const updateDashboardVendor = async (token, params, id) => {
  const objectName = 'dashboard_vendor'
  const url = `dashboard_vendors/${id}`

  const data = await apiPatch({ url, token, objectName, params })
  return data
}

export function useUpdateDashboardVendor({ options }) {
  const token = useContext(AuthContext)

  return useMutation(
    (params) => {
      return updateDashboardVendor(token, params, params.dashboard_vendor_id)
    },
    { ...options }
  )
}

const deleteDashboardVendor = async (token, id) => {
  const url = `dashboard_vendors/${id}`

  const data = await apiDelete({ url, token })
  return data
}

export function useDeleteDashboardVendor({ id, options }) {
  const token = useContext(AuthContext)

  return useMutation(
    () => {
      return deleteDashboardVendor(token, id)
    },
    { ...options }
  )
}

const bulkCreateDashboardVendors = async (token, dashboardId, vendorIds, options = 'include') => {
  const url = `dashboards/${dashboardId}/dashboard_vendors/bulk_create`
  const data = await apiPostQuery({ url, token, params: { vendor_ids: vendorIds, options } })
  return data
}

export function useBulkCreateDashboardVendors({ options }) {
  const token = useContext(AuthContext)

  return useMutation(
    ({ dashboardId, vendorIds, options: vendorOptions }) => {
      return bulkCreateDashboardVendors(token, dashboardId, vendorIds, vendorOptions)
    },
    { ...options }
  )
}

const bulkDestroyDashboardVendors = async (token, dashboardId) => {
  const url = `dashboards/${dashboardId}/dashboard_vendors/bulk_destroy`
  const data = await apiDelete({ url, token })
  return data
}

export function useBulkDestroyDashboardVendors({ options }) {
  const token = useContext(AuthContext)

  return useMutation(
    (dashboardId) => {
      return bulkDestroyDashboardVendors(token, dashboardId)
    },
    { ...options }
  )
}